import * as React from 'react';
import onClickOutside from 'react-onclickoutside';
import classnames from 'classnames';

import Button from '@components/Button';

export interface IDropdownButtonProps {
  options: IDropdownButtonOption[];
  label: string;
  buttonStyle: ButtonStyle;
  onClick?: TButtonOnClick;
}

interface IDropdownButtonState {
  show: boolean;
}

export class DropdownButton extends React.Component<IDropdownButtonProps, IDropdownButtonState> {
  constructor(props: IDropdownButtonProps) {
    super(props);
    this.state = this.getInitState();
  }

  getInitState = () => ({
    show: false,
  });

  handleClickOutside = () => {
    this.setState({
      show: false,
    });
  };

  onToggleDropdown = () => {
    this.setState((prevState) => ({
      show: !prevState.show,
    }));
  };

  handleClick = (option: IDropdownButtonOption) => (e: React.SyntheticEvent<HTMLElement>) => {
    if (option.isDisable) {
      return;
    }

    option.onClick(e);
    this.onToggleDropdown();
  };

  renderButton = () => (
    <Button bsStyle={this.props.buttonStyle} onClick={this.onToggleDropdown} content={this.props.label} />
  );

  renderDropdown = () =>
    this.state.show ? (
      <ul className={classnames('dropdown-button__dropdown-wrap')}>
        {this.props.options.map((option, index) => (
          <li
            key={`op-${index}`}
            onClick={this.handleClick(option)}
            className={classnames('dropdown-button__dropdown-wrap__list', {
              disabled: option.isDisable,
            })}
          >
            {option.label}
          </li>
        ))}
      </ul>
    ) : null;

  render() {
    return (
      <span className={classnames('dropdown-button')}>
        {this.renderButton()}
        {this.renderDropdown()}
      </span>
    );
  }
}

export default onClickOutside(DropdownButton);
